<template>
  <div>
    <v-row v-if="showLabel">
      <v-col cols="12" align="center">
        {{ labelValue }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <SimpleDatePicker
          label="From"
          :value="dateBeginValue"
          :maxDate="maxDateBegin"
          :maxDateEnable="maxDateBegin"
          :clearable="true"
          :disabled="disabled ? disabled : false"
          @selected-date-change="selectedDateBeginChangeHandler"
        ></SimpleDatePicker>
      </v-col>
      <v-col cols="12" sm="6">
        <SimpleDatePicker
          label="To"
          :value="dateEndValue"
          :minDate="minDateEnd"
          :minDateEnable="minDateEnd"
          :disabled="disabled ? disabled : false"
          :clearable="true"
          @selected-date-change="selectedDateEndChangeHandler"
        ></SimpleDatePicker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SimpleDatePicker from '@/components/shared/datePickers/SimpleDatePicker'

export default {
  components: { SimpleDatePicker },
  props: ['label', 'dateBegin', 'dateEnd', 'disabled', 'showLabel'],
  computed: {
    dateBeginValue: {
      get () {
        return this.dateBegin
      },
      set (newValue) {
        this.$emit('dateBeginChange', newValue)
      }
    },
    dateEndValue: {
      get () {
        return this.dateEnd
      },
      set (newValue) {
        this.$emit('dateEndChange', newValue)
      }
    },
    labelValue: {
      get () {
        return this.label ? this.label : 'Date Range'
      }
    },
    minDateEnd: {
      get () {
        if (!this.dateBegin) {
          return undefined
        }
        let dateBegin = new Date(this.dateBegin)
        let dateBeginTomorrow = new Date(this.dateBegin)
        // Add 1 Day
        dateBeginTomorrow.setDate(dateBegin.getDate() + 1)
        return dateBeginTomorrow.toISOString()
      }
    },
    maxDateBegin: {
      get () {
        if (!this.dateEnd) {
          return undefined
        }
        let dateEnd = new Date(this.dateEnd)
        let dateEndYesterday = new Date(this.dateEnd)
        // Add 1 Day
        dateEndYesterday.setDate(dateEnd.getDate() - 1)
        return dateEndYesterday.toISOString()
      }
    }
  },
  methods: {
    selectedDateBeginChangeHandler (newValue) {
      if (new Date(newValue) >= new Date(this.dateEndValue)) {
        this.dateEndValue = null
      }
      this.dateBeginValue = newValue
    },
    selectedDateEndChangeHandler (newValue) {
      this.dateEndValue = newValue
    }
  }
}

</script>
